import identityIcon from "@/libs/identityIcon";
import { mapState } from "vuex";
export default {
  name: "No",
  props: {
    data: {
      type: Object,
      default() {
        return {
          icon: identityIcon["ORG"],
          style: "width: 127px",
          content: $t("i2ya579", "当前组织无任何成员"),
          button: {
            text: $t("e7yhal4", "添加成员"),
            visible: true
          }
        };
      }
    }
  },
  computed: {
    ...mapState(["user"]),
    isAdmin() {
      return this.user.userInfo.isAdmin === "T";
    }
  },
  methods: {
    add() {
      this.$emit("add");
    }
  }
};